import fp from 'lodash/fp';

const userRoles = {
  PendingUser: 'PendingUser',
  User: 'User',
  ExternalUser: 'ExternalUser',
  BusinessAdmin: 'BusinessAdmin',
  Publisher: 'Publisher',
  SystemAdmin: 'SystemAdmin',
  IndustryAdmin: 'IndustryAdmin',
  Manager: 'Manager',
  SuperAdmin: 'SuperAdmin'
};

const findRole = (role) => fp.find((roleAssignment) => roleAssignment.role === role)

export const businessUserRoles = (roles) => fp.filter((roleAssignment) => roleAssignment.businessId)(roles);

export const pendingUserRole = (roles) => findRole(userRoles.PendingUser)(roles);

export const userRole = (roles) => findRole(userRoles.User)(roles);

export const externalUserRole = (roles) => findRole(userRoles.ExternalUser)(roles)

export const businessAdminRole = (roles) => findRole(userRoles.BusinessAdmin)(roles);

export const businessUserRole = (roles) => fp.flow(businessUserRoles, userRole)(roles);

export const publisherRole = (roles) => findRole(userRoles.Publisher)(roles);

export const superAdminRole = (roles) => findRole(userRoles.SuperAdmin)(roles);

export const systemAdminRole = (roles) => findRole(userRoles.SystemAdmin)(roles);

export const industryAdminRole = (roles) => findRole(userRoles.IndustryAdmin)(roles);

export const managerRole = (roles) => findRole(userRoles.Manager)(roles);

/**
 * Roles with priority based on the business rule.
 *  - Super Admin
 *  - System Admin
 *  - Publisher
 *  - Business Admin
 *  - Manager
 *  - User
 *  - External User (i.e. Come from Complii’s SSO API)
 *  - Pending User (i.e. has been invited but not accepted their invite)
 * 
 * @see https://complii.atlassian.net/browse/CADDIE-252?focusedCommentId=122868 for the role hierarchy.
 */
export const userRolePriorities = {
  SuperAdmin: {
    priority: 1,
    name: userRoles.SuperAdmin
  },
  SystemAdmin: {
    priority: 2,
    name: userRoles.SystemAdmin
  },
  Publisher: {
    priority: 3,
    name: userRoles.Publisher
  },
  BusinessAdmin: {
    priority: 4,
    name: userRoles.BusinessAdmin
  },
  Manager: {
    priority: 5,
    name: userRoles.Manager
  },
  User: {
    priority: 6,
    name: userRoles.User
  },
  ExternalUser: {
    priority: 7,
    name: userRoles.ExternalUser
  },
  PendingUser: {
    priority: 8,
    name: userRoles.PendingUser
  },
};

export default userRoles;



// WEBPACK FOOTER //
// ./src/constants/user-roles.js